import { Text } from '@betterment/samba-react';
import { Box } from '@betterment/style-closet-react';

import ResendInvites from './ResendInvites';

import { Referral } from '../data';

export type Props = {
  title: string;
  referralData: Referral[];
};

const InvitationListItem: React.FC<Props> = ({ title, referralData }) => {
  return (
    <Box key={title}>
      <Text
        as="p"
        css={{
          marginBottom: 'space.200',
          fontSize: 'fontSize.50',
        }}
      >
        {title}
      </Text>
      {referralData.map((referral, index) => {
        const isLastItemInList = referralData.length === (index += 1);

        return (
          <Box key={referral.email} mb={isLastItemInList ? '0' : '6'}>
            <Text
              as="p"
              key={referral.email}
              color="text.weak"
              css={{
                marginBottom: 'space.0',
              }}
            >
              {referral.email}
            </Text>
            {referral.status === 'prompt' && (
              <ResendInvites referralInviteId={referral.personalReferralInviteId || ''} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default InvitationListItem;
